import React, { Component } from "react";
import Logout from "../assets/logout.svg";
import Back from "../assets/back.svg";
// import RestaurantItem from '../components/RestaurantItem'
import licenseplan from "../assets/licenseplan.svg";
import { Modal } from "react-bootstrap";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import CustomButton from "../components/CustomButton";
import Tick from "../assets/tick.svg";
import { NumericFormat } from "react-number-format";
import Loading from "../components/Loading";
import Cancel from "../assets/cancel.svg";
import ListTable from "../assets/listtable.png";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import momentjalali from "moment-jalaali";
import moment from "moment-timezone";
import {
  BaseUrl,
  Authorization,
  BaseUrlPublic,
  LogoutFunction,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";

export default class LicensePlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoading: true,
      confirmLoading: false,
      licensePlans: [],
      ModalShow: false,
      currentItem: null,
      pageStatus: "normal",
      paymentToken: "",
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "عنوان",
          field: "title",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مدت اعتبار",
          field: "duration",
          cellRenderer: "formatDuration",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ با احتساب مالیات",
          field: "price",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "وضعیت",
          field: "status",
          cellRenderer: "formatStatus",

          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "شناسه تراکنش",
          field: "id",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "کد پیگیری",
          field: "traceNo",
          cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "createdAt",
          cellRenderer: "formatDateTime",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        formatCurrency: this.formatCurrency,
        formatString: this.formatString,
        formatDateTime: this.formatDateTime,
        formatStatus: this.formatStatus,
        formatDuration: this.formatDuration,
      },
      resID: null,
      tableLoading: true,
      subtitleText: "",
      ModalCodeShow: false,
      currentCode: 981,
      tabSelected: 1,
      invoiceLoading: false,
      price: 0,
      taxPrice: 0,
      totalPrice: 0,
      subscriptionType: 0,
    };

    this.getPackages = this.getPackages.bind(this);

    this.paymentForm = React.createRef();
    this.tableContainer = React.createRef();
  }

  formatStatus(params) {
    switch (params.value) {
      case "pending":
        return "در حال بررسی...";
      case "complete":
        return "تایید شده";
      case "failed":
        return "ناموفق";
      default:
        break;
    }
    return params.value;
  }

  formatDuration(params) {
    switch (params.value.toString()) {
      case "31":
        return "1 ماه";
      case "183":
        return "6 ماه";
      case "365":
        return "1 سال";
      default:
        break;
    }
    return params.value;
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" ریال"}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatString(params) {
    try {
      if (!params.value) return "-";
      return params.value;
    } catch (error) {
      return "-";
    }
  }

  formatDateTime(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      var zone_name = moment.tz.guess();
      let newdatetime = moment
        .tz(params.value, zone_name)
        .format("yyyy-MM-DD HH:mm")
        .toString()
        .split(" ");

      let result =
        newdatetime[1] +
        " " +
        momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD");

      return result;
    } catch (error) {
      return "-";
    }
  }

  componentDidMount() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    this.setState({ loading: true });

    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              resID: result.result[0].id,
              subscriptionType:
                result.result[0].subscriptionType === 1
                  ? 6
                  : result.result[0].subscriptionType,
            },
            () => {
              this.getPackages();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  getPackages() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getPackages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          let text = "";
          var zone_name = moment.tz.guess();
          let newdatetime = moment
            .tz(result.businessInfo.expireTime, zone_name)
            .format("yyyy-MM-DD HH:mm")
            .toString()
            .split(" ");

          if (result.businessInfo.title.toLowerCase() === "expire") {
            text =
              "اشتراک شما در تاریخ " +
              momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD") +
              " منقضی شده است. لطفاً سریعاً برای تمدید اشتراک خود اقدام نمایید";
          } else {
            text =
              "نوع اشتراک: " +
              result.businessInfo.titleFa +
              " - تاریخ انقضا: " +
              momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD");
          }

          this.setState({
            dataLoading: false,
            licensePlans: result.packages,
            subtitleText: text,
          });
        } else {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onBack() {
    if (this.state.subscriptionType === 3)
      this.props.history.push("/Restaurants");
    else this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  onLogout() {
    LogoutFunction();
  }

  onClickToBuy(id) {
    this.state.licensePlans.forEach((element) => {
      if (element.id === id) {
        element.du =
          this.state.tabSelected === 1
            ? "1 ماهه"
            : this.state.tabSelected === 2
            ? "6 ماهه"
            : "1 ساله";
        this.setState({ currentItem: element });
      }
    });

    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      packageId: id,
      duration:
        this.state.tabSelected === 1
          ? "1m"
          : this.state.tabSelected === 2
          ? "6m"
          : "1y",
    };
    data = Object.assign(data, Authorization());

    this.setState({ ModalShow: true, invoiceLoading: true });
    console.log(data);
    // return;
    fetch(BaseUrl + "subscriptionCalculatorEx", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          // this.setState({ rowData: result.result }, () => {
          this.setState({
            invoiceLoading: false,
            price: result.price,
            taxPrice: result.tax,
            totalPrice: result.totalPrice,
          });
          // });
        } else {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onConfirmToBuy() {
    this.setState({ invoiceLoading: true });

    let data = {
      packageId: this.state.currentItem.id,
      businessCode: this.props.match.params.id,
      duration:
        this.state.tabSelected === 1
          ? "1m"
          : this.state.tabSelected === 2
          ? "6m"
          : "1y",
    };
    data = Object.assign(data, Authorization());

    console.log(data);

    fetch(BaseUrl + "sendForPayment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          this.setState({ paymentToken: result.paymentToken }, () => {
            this.setState({ pageStatus: "bank" }, () => {
              window.setTimeout(() => {
                this.paymentForm.current.click();
              }, 50);
            });
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  hideModal1() {
    this.setState({ rowData: [], ModalShow1: false });
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  ShowHistoryOfRequests() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    this.setState({ ModalShow1: true, tableLoading: true });

    fetch(BaseUrl + "getTransactions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          console.log(result.result);
          this.setState({ rowData: result.result }, () => {
            this.setState({ tableLoading: false });
          });
        } else {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onMonthlyClick() {
    this.setState({ tabSelected: 1 });
  }

  onSixMonthClick() {
    this.setState({ tabSelected: 2 });
  }

  onYearlyClick() {
    this.setState({ tabSelected: 3 });
  }

  render() {
    if (!this.state.dataLoading)
      if (this.state.pageStatus === "normal")
        return (
          <div className="Login">
            <div className="header">
              <div
                onClick={this.onBack.bind(this)}
                className="linkStyle backButton"
              >
                <img
                  src={Back}
                  alt=""
                  className="backButtonIcon"
                  style={{ transform: "rotate(180deg)" }}
                />
                بازگشت
              </div>
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="خروج"
                  // data-place="bottom"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
            <div className="LoginContent">
              <div className="RestaurantsListTitle">اشتراک</div>
              {/* <div className="RestaurantsListSubTitle">خرید و تمدید اشتراک</div> */}
              <div className="RestaurantsListSubTitle">
                {this.state.subtitleText}
              </div>

              <div
                style={{ width: "95vw", maxWidth: "1200px", marginTop: "20px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "fit-content",
                  }}
                >
                  <CustomButton
                    title="نمایش سوابق درخواست"
                    imgHeight={20}
                    imgWidth={25}
                    flexDirection="row-reverse"
                    minHeight="35px"
                    img={ListTable}
                    onClick={this.ShowHistoryOfRequests.bind(this)}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "10px",
                  }}
                >
                  <div
                    className="licenceTab"
                    style={{
                      borderRadius: "0px 10px 10px 0px",
                      borderWidth: "2px",
                      backgroundColor:
                        this.state.tabSelected === 1
                          ? "var(--brown1)"
                          : "white",
                      color:
                        this.state.tabSelected === 1
                          ? "white"
                          : "var(--black1)",
                    }}
                    onClick={this.onMonthlyClick.bind(this)}
                  >
                    یک ماهه
                  </div>
                  <div
                    className="licenceTab"
                    style={{
                      borderWidth: "2px 0px 2px 0px",
                      backgroundColor:
                        this.state.tabSelected === 2
                          ? "var(--brown1)"
                          : "white",
                      color:
                        this.state.tabSelected === 2
                          ? "white"
                          : "var(--black1)",
                    }}
                    onClick={this.onSixMonthClick.bind(this)}
                  >
                    شش ماهه (%15-)
                  </div>
                  <div
                    className="licenceTab"
                    style={{
                      borderRadius: "10px 0px 0px 10px",
                      borderWidth: "2px",
                      backgroundColor:
                        this.state.tabSelected === 3
                          ? "var(--brown1)"
                          : "white",
                      color:
                        this.state.tabSelected === 3
                          ? "white"
                          : "var(--black1)",
                    }}
                    onClick={this.onYearlyClick.bind(this)}
                  >
                    یک ساله (%30-)
                  </div>
                </div>
                <div className="shopObjectContainerGrid">
                  {this.state.licensePlans.map((item, i) => {
                    return (
                      <div key={i} className="shopObjectContainer">
                        <div className="shopObjectItemSubscribe">
                          <div
                            style={{
                              fontFamily: "SFUIDisplayBold",
                              fontSize: "20px",
                              margin: "10px 0px",
                              textAlign: "center",
                            }}
                          >
                            {item.title}
                          </div>
                          <div
                            style={{
                              fontFamily: "SFUIDisplayBold",
                              color: "var(--gray3)",
                              fontSize: "14px",
                              marginBottom: "30px",
                              textAlign: "center",
                            }}
                          >
                            {item.title2}
                          </div>
                          {/* <div
                            style={{
                              width: "100%",
                              minHeight: "1px",
                              backgroundColor: "var(--brown1)",
                            }}
                          /> */}
                          <div
                            style={{
                              fontFamily: "SFUIDisplay",
                              fontSize: "14px",
                              width: "100%",
                              direction: "rtl",
                              textAlign: "right",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {item.descr.split(/\r?\n/).map((item, i) => {
                              return (
                                <div key={i} style={{ marginBottom: "10px" }}>
                                  {item}
                                </div>
                              );
                            })}
                          </div>
                          <div style={{ flex: "1" }} />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "flex-end",
                              marginBottom: "20px",
                            }}
                          >
                            <div
                              style={{
                                marginLeft: "10px",
                                marginBottom: "3px",
                                fontSize: "14px",
                                color: "var(--gray3)",
                              }}
                            >
                              ماهیانه:
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <NumericFormat
                                style={{
                                  fontFamily:
                                    this.state.tabSelected > 1
                                      ? "SFUIDisplay"
                                      : "SFUIDisplayBold",
                                  fontSize:
                                    this.state.tabSelected > 1
                                      ? "16px"
                                      : "18px",
                                  color:
                                    this.state.tabSelected > 1
                                      ? "var(--gray3)"
                                      : "var(--black1)",
                                  textDecoration:
                                    this.state.tabSelected > 1
                                      ? "line-through"
                                      : "none",
                                }}
                                value={item.monthlyPrice}
                                displayType={"text"}
                                thousandSeparator={true}
                                suffix={" ریال"}
                              />

                              {this.state.tabSelected > 1 && (
                                <NumericFormat
                                  style={{
                                    fontFamily: "SFUIDisplayBold",
                                    fontSize: "18px",
                                  }}
                                  value={
                                    this.state.tabSelected === 2
                                      ? item.monthlyPriceFor6m
                                      : item.monthlyPrice1y
                                  }
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  suffix={" ریال"}
                                />
                              )}
                            </div>
                          </div>
                          <CustomButton
                            title="خرید"
                            minHeight="35px"
                            onClick={this.onClickToBuy.bind(this, item.id)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <Modal
              show={this.state.ModalShow}
              size="sm"
              animation={true}
              onHide={this.hideModal.bind(this)}
              centered
            >
              {this.state.invoiceLoading && (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100px",
                  }}
                >
                  <WhisperSpinner
                    size={30}
                    color="var(--brown1)"
                    frontColor="var(--brown1)"
                    backColor="var(--brown1)"
                    loading={true}
                  />
                </div>
              )}
              {this.state.currentItem && !this.state.invoiceLoading && (
                <div className="dialogBox" style={{ maxHeight: "unset" }}>
                  آیا از خرید خود اطمینان دارید؟
                  <div
                    className="shopObjectItemSubscribe"
                    style={{ marginTop: "20px", height: "auto" }}
                  >
                    <div
                      style={{
                        fontFamily: "SFUIDisplayBold",
                        fontSize: "16px",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      نام اشتراک:&nbsp;{this.state.currentItem.title}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        color: "var(--gray3)",
                        fontFamily: "SFUIDisplay",
                        fontSize: "14px",
                        marginBottom: "30px",
                      }}
                    >
                      مدت:&nbsp;
                      <div>{this.state.currentItem.du}</div>
                    </div>
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "14px",
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <div>مبلغ:</div>
                      <div style={{ flex: "1" }} />
                      <NumericFormat
                        value={this.state.price}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" ریال"}
                      />
                    </div>
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "14px",
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <div> مالیات بر ارزش افزوده:</div>
                      <div style={{ flex: "1" }} />
                      <NumericFormat
                        value={this.state.taxPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" ریال"}
                      />
                    </div>
                    <div
                      style={{
                        fontFamily: "SFUIDisplayBold",
                        fontSize: "18px",
                        display: "flex",
                        flexDirection: "row",
                        color: "var(--brown1)",
                        marginTop: "10px",
                        width: "100%",
                      }}
                    >
                      <div>جمع کل:</div>
                      <div style={{ flex: "1" }} />
                      <NumericFormat
                        value={this.state.totalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" ریال"}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: "20px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: "1" }}>
                      <CustomButton
                        title="بله"
                        loading={this.state.confirmLoading}
                        imgHeight={20}
                        imgWidth={25}
                        minHeight="35px"
                        img={Tick}
                        onClick={this.onConfirmToBuy.bind(this)}
                      />
                    </div>
                    <div style={{ minWidth: "5px" }} />
                    <div style={{ flex: "0.8" }}>
                      <CustomButton
                        title="خیر"
                        imgHeight={19}
                        backColor="var(--black1)"
                        imgWidth={25}
                        minHeight="35px"
                        img={Cancel}
                        onClick={this.hideModal.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </Modal>

            <Modal
              show={this.state.ModalCodeShow}
              size="sm"
              animation={true}
              onHide={() => {
                this.setState({ ModalCodeShow: false });
              }}
              backdrop="static"
              centered
            >
              <div className="dialogBox">
                درخواست با موفقیت ثبت شد. لطفاً کد پیگیری زیر را به بخش پشتیبانی
                شرکت سپند اعلام کنید:
                <div
                  className="shopObjectItem"
                  style={{
                    marginTop: "20px",
                    height: "140px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "SFUIDisplayBold",
                      fontSize: "16px",
                      display: "flex",
                      flexDirection: "row",
                      color: "var(--brown1)",
                    }}
                  >
                    کد پیگیری:&nbsp;{this.state.currentCode}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="بستن"
                      imgHeight={19}
                      backColor="var(--black1)"
                      imgWidth={25}
                      minHeight="35px"
                      img={Cancel}
                      onClick={() => {
                        this.setState({ ModalCodeShow: false });
                      }}
                    />
                  </div>
                </div>
              </div>
            </Modal>

            <Modal
              show={this.state.ModalShow1}
              animation={true}
              backdrop="static"
              backdropClassName="backdropClassName"
              contentClassName="contanetStyleModal"
              onHide={this.hideModal1.bind(this)}
              centered
            >
              {!this.state.tableLoading && (
                <div className="RestaurantsListTitle">سوابق درخواست‌ها</div>
              )}
              {!this.state.tableLoading && (
                <div
                  className="pageContents"
                  style={{
                    width: "90vw",
                    maxWidth: "800px",
                    height: "auto",
                    alignItems: "center",
                  }}
                  ref={this.tableContainer}
                >
                  <div
                    className="tableContainer ag-theme-alpine"
                    style={{
                      minHeight: "55vh",
                      height: "55vh",
                    }}
                  >
                    <div
                      style={{
                        flex: "1",
                        width: "100%",
                        flexGrow: 1,
                        flexShrink: 0,
                        flexBasis: 0,
                      }}
                    >
                      <AgGridReact
                        enableRtl={true}
                        autoHeight={true}
                        animateRows={true}
                        enableBrowserTooltips={true}
                        tooltipMouseTrack={true}
                        suppressSizeToFit={false}
                        columnDefs={this.state.columnDefs}
                        localeText={this.state.gridLocaleText}
                        rowData={this.state.rowData}
                        suppressDragLeaveHidesColumns={true}
                        suppressMovable={true}
                        skipHeaderOnAutoSize={false}
                        onFirstDataRendered={this.onFirstDataRendered.bind(
                          this
                        )}
                        rowHeight={window.innerWidth <= 587 ? 40 : 50}
                        headerHeight={window.innerWidth <= 587 ? 40 : 50}
                        frameworkComponents={this.state.frameworkComponents}
                        enableCellTextSelection={true}
                        ensureDomOrder={true}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      maxWidth: "250px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: "20px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: "1" }}>
                      <CustomButton
                        title="بستن"
                        imgHeight={19}
                        backColor="var(--black1)"
                        imgWidth={25}
                        minHeight="35px"
                        img={Cancel}
                        onClick={this.hideModal1.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              )}

              {this.state.tableLoading && (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <WhisperSpinner
                    size={30}
                    color="var(--brown1)"
                    frontColor="var(--brown1)"
                    backColor="var(--brown1)"
                    loading={true}
                  />
                </div>
              )}
            </Modal>
            {/* <ReactTooltip effect="solid" /> */}
          </div>
        );
      else
        return (
          <form
            style={{ display: "none" }}
            // onLoad="document.forms['forms'].submit()"
            action="https://sep.shaparak.ir/OnlinePG/OnlinePG"
            method="post"
          >
            <input type="hidden" name="Token" value={this.state.paymentToken} />
            <input type="text" name="GetMethod" value="true" />
            <input
              ref={this.paymentForm}
              type="submit"
              name="submit"
              value="submit"
            />
          </form>
        );
    else return <Loading />;
  }
}
